/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-22 14:53:47
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-22 16:13:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/Title/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { getPageName } from '../slice';
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

const Title = () => {
  const _params: {
    saleChannelUuid: string;
    contentPageUuid: string;
    contentUuid: string;
  } = useParams();
  const { saleChannelUuid, contentUuid } = _params;
  const _h = useHistory();

  const name = useSelector(getPageName());
  const onClick = () => {
    _h.push(
      `/salesChannel/editor/content/contentPage/${saleChannelUuid}/${contentUuid}`,
    );
  };
  return (
    <div className={css.container} onClick={onClick}>
      <Icon type='iconleft' className={css.icon} />
      <div className={css.text}>
        {' '}
        <NoWrapContainer>
          <Tooltip title={name}>{name}</Tooltip>{' '}
        </NoWrapContainer>
      </div>
    </div>
  );
};
export default Title;
